import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { ReusableCustomQuestionField } from "../../shared/interfaces/ReusableCustomQuestionField";

export function useCustomQuestionsByCustomer(
  customerId?: number,
  callbacks?: QueryCallbacks<ReusableCustomQuestionField[]>,
) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["customQuestionsByCustomer", customerId],
    queryFn: async () => {
      if (customerId) return await apiContext.customWorkflowQuestionApis.getCustomQuestionsByCustomer(customerId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
